import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const homeFeaturedArticlesScroll = () => {
    if($('.section-featured-articles')[0]) {
        gsap.registerPlugin(ScrollTrigger)
    
        let sections = gsap.utils.toArray('.row-feature')
    
        gsap.to(sections, {
            xPercent: -100 * (sections.length - 1),
            ease: 'none',
            scrollTrigger: {
                trigger: '.featured-container',
                pin: true,
                scrub: 1,
                // snap: 1 / (sections.length - 1),
                snap: 0,
                end: () => '+=' + document.querySelector('.featured-container').offsetWidth
            }
        })
    }
}

export const teamCols = () => {
    const $el = $('.section-team .team-col')

    if($el[0]) {
        $el.each(function() {
            const el = $(this).find('.team-top')

            el.click(() => {
                if(el.hasClass('show')) {
                    el.removeClass('show')
                } else {
                    $el.find('.team-top').removeClass('show')
                    el.addClass('show')
                }
            })
        })
    }
}

export const backToTop = () => {
    const backToTopShow = () => {
        if ($(window).scrollTop() >= ($(window).height() * .8)) {
            $('.btn-toTop').addClass('show')
        } else {
            $('.btn-toTop').removeClass('show')
        }
    }

    backToTopShow()
    $(window).scroll(() => {
        backToTopShow()
    })
    
    $('.btn-toTop').click(() => {
        $('html, body').animate({scrollTop:0})
        return false
    })
}